// Enter here the user flows and custom policies for your B2C application
// To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
// To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview

export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_oneair_admin_signin",
        forgotPassword: "B2C_1_oneair_admin_forgotpassword"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://dnatatravelukb2c.b2clogin.com/dnatatravelukb2c.onmicrosoft.com/B2C_1_oneair_admin_signin",
        },
        forgotPassword: {
            authority: "https://dnatatravelukb2c.b2clogin.com/dnatatravelukb2c.onmicrosoft.com/B2C_1_oneair_admin_forgotpassword",
        },
    },
}